module.exports = __webpack_public_path__ + "media/images/il_admin/pdf-11x13-29897f40d15321cb93a297394422cc89.png";